export {isLoading} from './isLoading'

export function standardReducer(initialState, actions) {
  return function (state = initialState, action) {
    const handler = actions[action.type]
    return handler ? handler(state, action) : state
  }
}
